const state = () => ({
  tokenData: null,
  list: null,
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  appendData(state, data) {
    state[data.label].push(data.data);
  },
  setApiToken: (state, data) => {
    state.tokenData = data;
  },
};

const actions = {
  async getData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.jsonApiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response.status, `${this.$config.env.jsonApiURL}${url}`);
      });
  },
  async getViewData({ commit, state }, { url, token }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    // if (token) body.headers = { Authorization: `Bearer ${token}` }
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {
        // console.log(response, url, "DEBUGA");
      });
  },
  // Used by Vixio API which may not be used in future
  async apiToken({ commit }, { email, password }) {
    const data = {
      email,
      password,
    };
    const body = {
      method: "POST",
      url: `${this.$config.vixioAuthURL}/authentication_token`,
      headers: {
        "Content-Type": "application/json",
      },
      progress: false,
      data,
    };

    return await this.$axios(body)
      .then((data) => data.data)
      .catch(({ response }) => {
        // console.log(response);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
